import { InitialPaymentPageContent } from '../components/management/initialPayment/InitialPaymentPageContent'

export const InitialPaymentPage = () => {
  return <InitialPaymentPageContent />
}
